import type { RouteMetricsResult } from '../api';
import { PAVEMENT_LABELS } from './layers';

/** Resumen chico de "sobre el recorrido" — mismo componente en Ficha y Visor. */
export function RouteMetricsSummary({
  metrics,
  className = 'ft-block',
}: {
  metrics: RouteMetricsResult;
  className?: string;
}): JSX.Element {
  return (
    <div className={className}>
      <p className="ft-block-title">Recorrido</p>
      <div className="ft-kpi-row">
        <div className="ft-kpi">
          <span className="ft-kpi-value">{metrics.trafficSignals.count}</span>
          <span className="ft-kpi-label">Semáforos</span>
        </div>
        <div className="ft-kpi">
          <span className="ft-kpi-value">{metrics.trafficCalming.count}</span>
          <span className="ft-kpi-label">Reductores</span>
        </div>
        <div className="ft-kpi">
          <span className="ft-kpi-value">{metrics.railwayCrossings.count}</span>
          <span className="ft-kpi-label">Pasos ferroviarios</span>
        </div>
      </div>
      <div className="ft-pavement">
        {metrics.pavement.breakdown
          .filter(b => b.pct > 0)
          .map(b => (
            <span key={b.bucket} className="ft-pavement-chip">
              {PAVEMENT_LABELS[b.bucket]} {b.pct}%
            </span>
          ))}
        {metrics.pavement.totalLengthM === 0 && <span className="ft-pavement-chip">Sin tramos</span>}
      </div>
    </div>
  );
}
